import { useQuery } from '@tanstack/react-query';
import { ScheduleDataTrend } from '@demind-inc/core';

import { dataTrendApi } from '../api';

interface UseScheduleDailyTrendParams {
  dataTrendId: string;
  date: string;
  enabled?: boolean;
}

interface UseScheduleDailyTrendQueryParams {
  queryKey: ['lifestack.trend.schedule.daily', UseScheduleDailyTrendParams];
}

export const useScheduleDailyTrend = ({
  dataTrendId,
  date,
  enabled = true,
}: UseScheduleDailyTrendParams) => {
  const scheduleTrendQuery = useQuery({
    queryKey: ['lifestack.trend.schedule.daily', { dataTrendId, date }],
    queryFn: ({ queryKey }: UseScheduleDailyTrendQueryParams) => {
      const [, { dataTrendId, date }] = queryKey;
      return dataTrendApi
        .getScheduleDailyTrend(date, dataTrendId)
        .then(({ data }) => data as ScheduleDataTrend);
    },
    refetchOnWindowFocus: false,
    staleTime: 15000, // 15s
    enabled: !!dataTrendId && enabled,
  });

  return {
    scheduleTrend: scheduleTrendQuery.data,
    ...scheduleTrendQuery,
  };
};
